import paymentApi from './paymentApi';

const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

async function parseBlobPayload(blob) {
  try {
    const text = await blob.text();
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

function filenameFromDisposition(disposition) {
  if (!disposition) return '';
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (encoded) {
    try {
      return decodeURIComponent(encoded.replace(/^"|"$/g, ''));
    } catch {
      return encoded.replace(/^"|"$/g, '');
    }
  }
  return disposition.match(/filename="?([^";]+)"?/i)?.[1] || '';
}

function fallbackFilename() {
  const now = new Date();
  const pad = value => String(value).padStart(2, '0');
  return `小影点数流水_${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`;
}

export async function downloadCreditLedger({ scope = 'personal' } = {}) {
  let response;
  try {
    response = await paymentApi.get('/credit-account/export', {
      params: { scope, view: 'operations' },
      responseType: 'blob',
      validateStatus: () => true,
    });
  } catch (error) {
    const payload = error.response?.data instanceof Blob
      ? await parseBlobPayload(error.response.data)
      : error.response?.data;
    const exportError = new Error(payload?.message || '点数流水导出失败，请稍后重试');
    exportError.code = payload?.data?.error_code || '';
    throw exportError;
  }

  const contentType = String(response.headers?.['content-type'] || response.data?.type || '').toLowerCase();
  if (contentType.includes(XLSX_CONTENT_TYPE) && response.data instanceof Blob) {
    return {
      blob: response.data,
      filename: filenameFromDisposition(response.headers?.['content-disposition']) || fallbackFilename(),
    };
  }

  const payload = response.data instanceof Blob
    ? await parseBlobPayload(response.data)
    : response.data;
  const error = new Error(payload?.message || '点数流水导出失败，请稍后重试');
  error.code = payload?.data?.error_code || '';
  throw error;
}

export function saveCreditLedgerExport({ blob, filename }) {
  const url = window.URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename || fallbackFilename();
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(url), 0);
}
